import { api } from '../../../services/api.js';

async function getMiniDialog(token, moduleId, medialinkId, miniDialogId, studioGroup) {
    const { data } = await api.get(`api/studio/modules/${moduleId}/medialinks/${medialinkId}/mini-dialogs/${miniDialogId}`, {
        headers: {
            Authorization: `Bearer ${token}`,
            studioGroup,
        },
    });
    return data;
}
async function getSignedUrls(token, fileIds) {
    const { data: { data }, } = await api.post('/api/s3-files/sign-urls?extendedTimeValidity=true', { ids: fileIds }, {
        headers: {
            Authorization: `Bearer ${token}`,
        },
    });
    return data;
}

export { getMiniDialog, getSignedUrls };
